import { NextPage } from "next";

import SpecialFeatureTemplate from "@/components/page/page-special-feature/SpecialFeatureTemplate";

const Index: NextPage = () => <SpecialFeatureTemplate />;

export default Index;
